// 找商机-展商端-编辑
<template>
  <div class="find-oppirtunity-view" v-loading="loading">
    <div class="bl-container">
      <opportunity-item v-for="(item, index) in dataList" :key="'opportunity_' + index" 
      :item="item" 
      styleType="exhibitor-edit"
      @deleteItem="deleteItem"
      ></opportunity-item>
    </div>
    <div class="bl-container op-pagination">
      <el-pagination
        @current-change="pageChange"
        v-if="dataList.length > 0"
        background
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <hNoData v-if="dataList.length == 0"></hNoData>
  </div>
</template>
<script>

import opportunityItem from '@/components/business/opportunityItem.vue'
import { getMyCommercialDistrictList } from '../../api/opportunity.js'
import hNoData from '@/components/hNoData'
export default {

  components: {
    opportunityItem,
    hNoData
  },
  data() {
    return {
      value: '',
      options: [],
      loading: false,
      busy: false,
      page: 1,
      testList: ["1","2","3","4"],
      dataList: [],
      total: 0,
    }
  },
  computed: {
   
  },
  mounted() {
   this.getData(1);
  },
  methods: {
    getData (page) {
      var params = {
        pageNum: page,
        pageRows: 10
      }
      this.loading = true;
      getMyCommercialDistrictList(params).then(res => {
        return res.data
      }).then(res => {
        this.loading = false;
        if (res.code === 1000) {
          let data = res.data
          this.dataList = data.list;
          this.total = data.total;
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    pageChange (page) {
      this.getData(page);
    },
    deleteItem (id) {
      this.dataList = this.dataList.filter(d => {
        return d.commercialDistrictId != id;
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.find-oppirtunity-view {
  background-color : $color-white;
}
.op-pagination {
  text-align : right;
  margin-top : 60px;
  width : 612px;
  padding-bottom : 60px;
}
</style>
